/**
 * 申請受付　定数記録用ファイル
 */

import { Constants } from '@/CommonUtils/fixed/Constants';

// tslint:disable-next-line:no-namespace
export namespace UketsukeConstants {

  export const UKETSUKE_URL: string = Constants.DOMAIN_URL + Constants.PROJECT_URL + '/uketsuke';

  // 受注者メインメニュー
  /** 受注者トップメニューパス */
  export const ACCEPTER_TOPMENU_PATH: string = UKETSUKE_URL + '/accepterTopMenu';
  /** 受注者メインメニューパス */
  export const ACCEPTER_MAINMENU_PATH: string = UKETSUKE_URL + '/accepterMainMenu';

  // 申請書登録
  /** 申請書登録パス(※サービス作成後修正) */
  export const APP_FORM_PATH: string = UKETSUKE_URL + '/';
  /** 申請書登録パス　init */
  export const APP_FORM_PATH_INIT: string = APP_FORM_PATH + Constants.PATH_TAIL_INIT;
  /** 申請書登録（業者種別TraderType）　イベント管理用定数：工事 */
  export const APP_FORM_CONST: string = '00';
  /** 申請書登録（業者種別TraderType）　イベント管理用定数：委託 */
  export const APP_FORM_CONSUL: string = '01';
  /** 申請書登録（業者種別TraderType）　イベント管理用定数：物品 */
  export const APP_FORM_GOODS: string = '11';
  /** 申請書登録ファイル名 */
  export const APP_FORM_FILE: string = 'AppForm.json';
  /** 申請業者情報 */
  export const APP_TARDER_PATH: string = UKETSUKE_URL + '/ApplicationTraderInfo';
  /** 添付書類受付確認 */
  export const CHECK_APP_ACEPT_PATH: string = UKETSUKE_URL + '/CheckApplicationAccept';
  /** パスワード発行業者検索 */
  export const PASS_ISSUER_PATH: string = UKETSUKE_URL + '/PasswordIssuerSearch';
  /** パスワード送付書作成 */
  export const PASS_FORM_OUTPUT: string = UKETSUKE_URL + '/PasswordFormOutput';
  /** 変更申請履歴 */
  export const APP_CHANGE_LOG: string = UKETSUKE_URL + '/change-log';
  //2024/01/05 [2023L-14] add start
  /** 申請履歴検索 */
  export const PRO_HISTRIES_PATH: string = UKETSUKE_URL + '/processHistories';
  //2024/01/05 [2023L-14] add end

  // ユーザ登録
  /** ユーザ登録パス */
  export const USER_REGIST_PATH: string = UKETSUKE_URL + '/user-regist';
  /** ユーザ登録パス　init */
  export const USER_REGIST_PATH_INIT: string = USER_REGIST_PATH + Constants.PATH_TAIL_INIT;
  /** ユーザ登録パス　新規登録 */
  export const USER_REGIST_PATH_CREATE: string = USER_REGIST_PATH + Constants.PATH_TAIL_CREATE;

  // 自治体選択
  /** 自治体選択パス */
  export const MUNICIPAL_PATH: string = UKETSUKE_URL + '/municipal';
  /** 自治体パス　新規 */
  export const MUNICIPAL_PATH_CREATE: string = MUNICIPAL_PATH + Constants.PATH_TAIL_CREATE;
  /** 自治体パス　更新 */
  export const MUNICIPAL_PATH_UPDATE: string = MUNICIPAL_PATH + Constants.PATH_TAIL_UPDATE;

  // 個別情報登録
  /** 個別情報登録パス */
  export const PARTIAL_PATH: string = UKETSUKE_URL + '/partial';
  /** 個別情報登録 工事 */
  export const PARTIAL_PATH_CONST: string = PARTIAL_PATH + '/const';
  /** 個別情報登録 工事 */
  export const PARTIAL_PATH_CONSUL: string = PARTIAL_PATH + '/consul';
  /** 個別情報登録 物品 */
  export const PARTIAL_PATH_GOODS: string = PARTIAL_PATH + '/goods';
  // 2023.07.04 [2023F-05] add start
  // パスワード再設定
  /** パスワード再設定 */
  export const PASSWORD_RECONFIG_PATH: string = UKETSUKE_URL + '/password-reconfig';
  /** 要求 */
  export const PASSWORD_RECONFIG_REQUEST_PATH: string = PASSWORD_RECONFIG_PATH + '/request';
  // 2023.07.04 [2023F-05] add end
}
